<icc-list [searchable]="true" [items]="colors"
          [itemTemplate]="'itemColor'"
          (select)="select($event)"></icc-list>
